import React from 'react';
import {Helmet} from 'react-helmet-async';
import metaImage from "../../assets/gallery-img/store.png";

const AboutHelmet = () => {
    const socialLinks = {
        facebook: 'https://www.facebook.com/oldhousepartsco/',
        instagram: 'https://www.instagram.com/oldhousepartsco/',
        youtube: 'https://www.youtube.com/channel/UCJ0NXly6M11FTWWmKQS3Piw',
      };
    
      return (
        <div>
          <Helmet>
            <title>Old House Parts - About</title>
            <meta name="description" content="Every vintage treasure in our inventory is salvaged from local architecture. We pride ourselves in offering a pathway to create beautiful homes from recycled antiques from the 18th, 19th, and 20th century." />
            <meta name="keywords" content="Old House Parts, Antique Shop, Kennebunk, Maine, Architectural, Salvage, Vintage Furniture, Sustainavble, Local, Historic" />
    
            <meta property="og:url" content="https://www.oldhouseparts.com" />
            <meta property="og:title" content="Old House Parts Co." />
            <meta property="og:description" content="Explore our collection of vintage furniture, art, and collectibles at Old House Parts Co. in Kennebunk, Maine." />
            <meta property="og:image" content={metaImage} />
    
            {/* Facebook */}
            <meta property="article:publisher" content={socialLinks.facebook} />
            {/* Instagram */}
            <meta property="instagram:site" content={socialLinks.instagram} />
            {/* YouTube */}
            <meta property="youtube:channel" content={socialLinks.youtube} />
          </Helmet>
        </div>
      )
}

export default AboutHelmet
